import { render, staticRenderFns } from "./banned_people.vue?vue&type=template&id=7e2c5a40&scoped=true"
import script from "./banned_people.vue?vue&type=script&lang=js"
export * from "./banned_people.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c5a40",
  null
  
)

export default component.exports